<template>
  <div class="menu-item">
    <router-link :to="path" @click.native="handleClick" class="menu-link">
      {{ text }}
    </router-link>
    <p class="menu-caption">
      {{ caption }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'menu-item',
  props: {
    path: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped lang="scss">
.menu-link {
  display: inline-block;
  color: #002560;
  font-size: $header-size-5;
  margin-bottom: $margin-xs;
  border-bottom: 2px solid #002560;
  font-size: 16px;
  font-weight: 500;
}
.menu-caption {
  color: #777e85;
  font-size: 12px;
  max-width: 300px;
}
</style>
